import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './components/header/header.component';
import { FooterComponent } from './components/footer/footer.component';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { AppNotificationService } from './services/app-notifications.service';
import { ImagePreloadDirective } from './directives/image.directive';
import {MatDialogModule} from '@angular/material/dialog';
import { NgSelectModule } from '@ng-select/ng-select';
import { RouterModule } from '@angular/router';
import {MatDatepickerModule} from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { LoadingBarHttpClientModule } from '@ngx-loading-bar/http-client';
import { MatMomentDateModule, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { LogoComponent } from './components/logo/logo.component';
import { OrganizationComponent } from './components/organization/organization.component';
import { OrganizationDetailsComponent } from './components/organization-details/organization-details.component';
import { ConfirmComponent } from './components/confirm/confirm.component';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { NgxSpinnerModule } from "ngx-spinner";

@NgModule({
  declarations: [
      HeaderComponent,
      FooterComponent,
      LogoComponent,
      ImagePreloadDirective,
      LogoComponent,
      OrganizationComponent,
      OrganizationDetailsComponent,
      ConfirmComponent
    ],
  imports: [
    CommonModule,
    RouterModule,
    NgSelectModule,
    HttpClientModule,
    FormsModule,
    InfiniteScrollModule,
    NgxSpinnerModule
  ],
  exports: [
    HeaderComponent,
    FooterComponent,
    LogoComponent,
    OrganizationComponent,
    OrganizationDetailsComponent,
    ConfirmComponent,
    FormsModule,
    HttpClientModule,
    ImagePreloadDirective,
    MatDialogModule,
    NgSelectModule,
    MatDatepickerModule,
    MatMomentDateModule,
    MatNativeDateModule,
    RouterModule,
    LoadingBarHttpClientModule
  ],
  providers: [],
  entryComponents: [ConfirmComponent]
})
export class SharedModule {
    static forRoot(): ModuleWithProviders<any> {
        return {
            ngModule: SharedModule,
            providers: [
                AppNotificationService,
                { provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { useUtc: true } }
              
            ]
        }
    }
}